<template>
  <!-- 导航栏组件 -->
  <el-menu
    class="header-menu"
    mode="horizontal"
    router
    :ellipsis="false"
    :default-active="defaultActive"
  >
    <el-menu-item
      v-for="item in menus"
      :key="item.path"
      :index="item.path.split('#')[0]"
      @click="handleMenuChange(item)"
    >
      {{ item.title }}
    </el-menu-item>
  </el-menu>
</template>

<script lang="ts" setup>
import { useMenu } from '~/composables/useMenu'

const { menus, defaultActive, handleMenuChange } = useMenu()
</script>

<style scoped lang="scss">
.header-menu {
  --menu-active-bgcolor: rgba(255, 255, 255);
  --el-menu-horizontal-height: 32px;
  --el-menu-border-color: transparent;
  --el-menu-bg-color: transparent;
  --el-menu-hover-bg-color: var(--menu-active-bgcolor);
  --el-menu-hover-text-color: #3b5cff;
  --el-menu-text-color: rgba(0,0,0,0.9);
  --el-menu-active-color: #3b5cff;
  gap: 16px;
  .el-menu-item {
    --el-menu-hover-bg-color: var(--menu-active-bgcolor);
    --el-menu-hover-text-color: #3b5cff;
    --el-menu-active-color: #3b5cff;
    --el-menu-text-color: rgba(0,0,0,0.9);
    --el-menu-item-font-size: 18px;
    border-radius: 4px;
    border-bottom: 0;
    &.is-active {
      background-color: var(--menu-active-bgcolor);
    }
  }
  :deep(.el-sub-menu) {
    border-radius: 4px;
    &:hover,
    &.is-active {
      background-color: var(--menu-active-bgcolor);
    }
    .el-sub-menu__title {
      border-bottom: none;
      --el-menu-text-color: rgba(0,0,0,0.9);
    }
  }
}
</style>
